import { Component, computed, OnInit, signal, inject } from '@angular/core';
import { AccountLogic } from '@mwe/services';
import { NotificationBannerComponent } from '../../notification-banner/notification-banner.component';

@Component({
  selector: 'mwe-impersonate-warning',
  templateUrl: './impersonate-warning.component.html',
  styles: [
    `
      .blinking-background {
        background-color: red;
        animation: blinkingText 1.5s 5;
      }

      @keyframes blinkingText {
        0% {
          background-color: red;
        }
        50% {
          background-color: #d9a300;
        }
      }
    `,
  ],
  imports: [NotificationBannerComponent],
})
export class ImpersonateWarningComponent implements OnInit {
  private accountLogic = inject(AccountLogic);

  email = signal<string>(null);
  protected readonly text = computed(() => `<b>Achtung:</b> Kollaborieren-Session für User <b>${this.email()}</b> aktiv!`);

  ngOnInit(): void {
    this.email.set(this.accountLogic.getAccountEmail());
  }
}
